const COMPANY_BY_STATE = {
  BB: 'LOTTO Brandenburg',
  BE: 'LOTTO Berlin',
  BW: 'LOTTO Baden-Württemberg',
  BY: 'LOTTO Bayern',
  HB: 'LOTTO Bremen',
  HE: 'LOTTO Hessen',
  HH: 'LOTTO Hamburg',
  MV: 'LOTTO Mecklenburg-Vorpommern',
  NI: 'LOTTO Niedersachsen',
  NW: 'WestLotto',
  RP: 'LOTTO Rheinland-Pfalz',
  SH: 'LOTTO Schleswig-Holstein',
  SL: 'Saartoto',
  SN: 'Sachsenlotto',
  ST: 'LOTTO Sachsen-Anhalt',
  TH: 'LOTTO Thüringen',
};

export default function getCompanyNameByState(state: string) {
  return COMPANY_BY_STATE[state];
}

export function getCompanyShortnames() {
  return COMPANY_BY_STATE;
}
